export const initialDataReducerState = {
  data: undefined, // The current data. Usually comes from a fetch.
  updatedData: {}, // 'dirty' data. Keys added as edits are made.
  dirty: false, // Whether updatedData has unsaved data.
};

export const DataReducerActions = {
  clear: 'clear',
  reload: 'reload',
  set: 'set',
  update: 'update',
};

// Reducer that works well with dataFormatters.
// Safe to use with state that has more keys than the above example state.
// See building/BuildingNav.jsx for an example of how this can compose with other reducers.
export function dataReducer(state, { action, payload }) {
  switch (action) {
    case DataReducerActions.set:
      return {
        ...state,
        data: payload,
        updatedData: {},
        dirty: false,
      };
    case DataReducerActions.update: {
      // Payload is expected to be an object in this case.
      // E.G. dispatch({action:DataReducerActions.update, payload:{key: 'complexId', value: 20 }});
      const { key, value: newValue } = payload;
      const { data, updatedData } = state;
      const newData = { ...updatedData };

      if (data && newValue === data[key]) {
        delete newData[key];
      } else {
        newData[key] = newValue;
      }

      return { ...state, updatedData: newData, dirty: Object.keys(newData).length > 0 };
    }
    case DataReducerActions.clear: {
      return { ...state, updatedData: {}, dirty: false };
    }
    default:
      return state;
  }
}
